/**
 * This bootstrap file is used for both frontend and core
 */

import _ from "lodash";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import "popper.js"; // Required for BS4
import "bootstrap";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _; // Lodash
window.moment = require("moment");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.addInterceptor = (token, withSp = true) => {
  const services = ["eventsHandler", "admin/bulk-upload", "admin/slack", "api/task" , "api/livechat" , "task/external" ];

  window.axios.defaults.headers.common["Authorization"] = `Bearer ${decodeURI(token)}`;
  window.axios.interceptors.request.use(
    function (config) {
      let { origin } = window.location;
      const { url, params } = config;
      const urls = url.split(origin);
      const [zero, one] = urls;

      services.forEach((service) => {
        if (/^\/app\//.test(one ?? zero) || (one ?? zero).indexOf(service) >= 0) {
          const [_, __, ...api] = (one ?? zero).split("/");
          let newUrl = `${origin}/api/${api.join("/")}`;

          if (withSp) {
            const newSP = new URLSearchParams(window.location.search);

            if (newSP.has("sp")) {
              if (params) {
                config.params = { ...params, sp: newSP.get("sp") };
              } else config.params = { sp: newSP.get("sp") };
            }
          }
          config.url = newUrl;
        }
      });

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
};

let uri = window.location.href.split("?");

if (uri.length == 2) {
  let vars = uri[1].split("&");
  let getVars = {};
  let tmp = "";
  vars.forEach(function (v) {
    tmp = v.split("=");
    if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
  });
  const { token } = getVars;

  if (token) {
    addInterceptor(token);
  } else if (window.settings?.auth) {
    window.addInterceptor(window.settings.auth.token, false);
  }
} else if (window.settings?.auth) {
  window.addInterceptor(window.settings.auth.token, false);
}

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
if (document.querySelector('meta[name="csrf-token"]')) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo";

// window.Pusher = require("pusher-js");

// window.Echo = new Echo({
//   broadcaster: "pusher",
//   key: "772696", // process.env.MIX_PUSHER_APP_KEY,
//   cluster: "dd1cd7da28e211a41bd7", //process.env.MIX_PUSHER_APP_CLUSTER,
//   forceTLS: true,
// });
